import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { trackCreatorVisit } from "@/lib/api";

export default function CreatorReferral() {
  const { code } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    let cancelled = false;
    const visit = async () => {
      try {
        const key = `hm_creator_visitor_${code.toUpperCase()}`;
        let token = localStorage.getItem(key);
        if (!token) {
          token = crypto.randomUUID().replaceAll("-", "");
          localStorage.setItem(key, token);
        }
        const referral = await trackCreatorVisit(code, token);
        localStorage.setItem("hm_creator_referral_code", code.toUpperCase());
        localStorage.setItem("hm_creator_referral_tier", referral.applicableTier || "pro");
        if (!cancelled) navigate("/auth?mode=signup", { replace: true });
      } catch {
        if (!cancelled) navigate("/", { replace: true });
      }
    };
    visit();
    return () => { cancelled = true; };
  }, [code, navigate]);
  return <div className="min-h-screen grid place-items-center bg-[#0a0a0a] text-white text-sm tracking-widest uppercase">Opening HustlrMate…</div>;
}
